// extracted by mini-css-extract-plugin
export default {"video-model":"video-model_pyPFY","ant-modal-content":"ant-modal-content_u7xbu","speech-display":"speech-display_G4gSI","video":"video_fFLwv"};